export enum ExtractTypeEnum {
  pix = 'PIX',
  ted = 'TED',
  doc = 'DOC',
  boleto = 'PAGAMENTO DE BOLETO',
  internal_transfer = 'TRANSFERÊNCIA ENTRE CONTAS LADYBANK',
  interna = 'ENTRE CONTAS LADYBANK'
}

export enum ExtractOptionsEnum {
  checking = 'checking',
  savings = 'savings',
  investment = 'investment',
  sub_account = 'sub_account',
  cash_balance = 'cash_balance',
  // TODO - outros
  credit_card = 'credit_card',
  loans = 'loans',
  insurance = 'insurance',
  foreign_currencies = 'foreign_currencies',
}